import clsx from 'clsx';

export function Label({ className, children, htmlFor }) {
  return (
    <label
      htmlFor={htmlFor}
      className={clsx(
        'mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300',
        className,
      )}
    >
      {children}
    </label>
  );
}

export default Label;
